export const getModelNameFromId = (modelId: string) => {
  const modelIdParts = modelId.split('-');

  //model id will always have 1 hyphen (-) separating make id and model
  //but in some cases the value passed to this function maybe `any_model` or something similar, representing a null value
  return modelIdParts.length === 2 ? modelIdParts[1] : modelId;
};
